import React from "react";
import ReactDOM from "react-dom/client";
import { App as AntdApp } from "antd";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "antd/dist/reset.css";
import "./styles.css";
import { ThemeProvider } from "./theme/ThemeProvider";
import { queryClient } from "./lib/query";
import App from "./App";

// Bật locale-aware format ("L", "LL", "LT"...) cho dayjs.
// DateRangePicker dùng `format="L"` → auto render theo locale hiện tại
// (vi: 22/05/2026, en: 05/22/2026). Đổi locale ở 1 chỗ tương lai sẽ
// đồng bộ toàn bộ DatePicker mà không phải sửa từng file.
dayjs.extend(localizedFormat);
dayjs.locale("vi");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <AntdApp>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </AntdApp>
    </ThemeProvider>
  </React.StrictMode>,
);
